import qs from 'qs';
import { useQuery } from 'react-query';
import { MutationType } from '../../../shared/types';
import request from '../../../utils/request';

export type SearchByType = 'contact' | 'list' | 'segment';
export type SearchResultType = {
  ids: string[] | null;
  type: SearchByType;
};

export const useSearch = ({
  search_by,
  callback,
  search_value,
  enabled = true,
}: MutationType & {
  search_value: string;
  search_by: 'contact' | 'list' | 'segment';
}) => {
  return useQuery(
    'search',
    async () => {
      const data: SearchResultType = await request(
        `/contacts/search?${qs.stringify({
          search_value,
          search_by,
        })}`,
      );
      return data;
    },
    {
      enabled: enabled && Boolean(search_value),
      onSuccess: (response: SearchResultType) => {
        if (callback) callback(true, response);
      },
      onError: (err) => {
        if (callback) callback(false, err);
      },
    },
  );
};
